/* global canAutoplay */

"use strict";

( function( namespace ) {
	var canAutoPlay = true;
	var lumiereReady = false;
	var isImaSdkLoaded = false;
	var isImaSdkReady = false;
	var isGaLoaded = false;
	var isGaReady = false;
	var jsStartTime;

	var init = function() {
		if ( lumiereReady ) {
			return;
		}

		lumiereReady = true;

		var evt = document.createEvent( "CustomEvent" );
		evt.initCustomEvent( "lumiere:ready", false, false, undefined );
		window.dispatchEvent( evt );
	};

	/**
	* Load player script dependencies - IMA SDK, Analyics SDK.
	*/
	var loadPlayerScripts = function() {
		jsStartTime = Date.now();

		if ( !namespace.isScriptLoaded( namespace.getImaSdkUrl() ) ) {
			namespace.loadScript( namespace.getImaSdkUrl() );
		}
		if ( !namespace.isScriptLoaded( namespace.getGaUrl() ) ) {
			namespace.loadScript( namespace.getGaUrl() );
		}
	};

	var getDehydratedRecsCount = function( el ) {
		if ( !window.hearstLumiereRecs ) {
			return null;
		}

		var recIndex = namespace.getVideoRecIndex( el.getAttribute( "data-article-id" ) );
		if ( recIndex < 0 ) {
			return 0;
		}

		if ( typeof ( window.hearstLumiereRecs[ recIndex ].embeds ) === "undefined" ) {
			return 0;
		}

		if ( window.hearstLumiereRecs[ recIndex ].embeds.length === 0 ) {
			return 0;
		}

		var watchedList = getVideoWatchedList();

		window.hearstLumiereRecs[ recIndex ].embeds = window.hearstLumiereRecs[ recIndex ].embeds.filter( function( embed ) {
			return watchedList.indexOf( embed ) === -1;
		} );

		return window.hearstLumiereRecs[ recIndex ].embeds.length;
	};

	/**
	* Query document and initialize any found video elements.
	*/
	var loadVideos = function() {
		var videos = document.getElementsByClassName( namespace.getPlayerClass() );

		if ( videos ) {
			for ( var i = 0; i < videos.length; i++ ) {
				if ( namespace.hasClass( videos[ i ], namespace.getVideoLoadedClass() ) ) {
					continue;
				}

				var dehydratedRecs = getDehydratedRecsCount( videos[ i ] );
				if ( dehydratedRecs > 0 ) {
					namespace.hydratePlaylist( videos[ i ], false );
				} else {
					namespace.getNitehawkData( videos[ i ] );
				}
			}
		}
	};

	/**
	* Retrieve facebook App ID from meta tag.
	* @returns {string}.
	*/
	var getFbAppId = function() {
		var metas = document.getElementsByName( "fb:app_id" );

		if ( metas ) {
			for ( var i = 0; i < metas.length; i++ ) {
				if ( metas[ i ].hasAttribute( "content" ) ) {
					return metas[ i ].getAttribute( "content" );
				}
			}
		}

		return null;
	};

	/**
	* Video player entry point.
	*/
	namespace.start = function() {
		var startInternal = function() {
			namespace.loadEnvVars();

			loadPlayerScripts();

			namespace.videojs = videojs;

			if ( namespace.getLogLevel() === "all" ) {
				namespace.videojs.log.level( "all" );
			} else {
				namespace.videojs.log.level( "error" );
			}

			var loadFail = function() {
				videojs.log.error( "timeout waiting for DOM ready" );
			};

			namespace.waitForThenRun( namespace.isDOMReady, loadVideos, loadFail );
		};

		canAutoplay.video( {
			timeout: 500,
			inline: true,
		} ).then( function( response ) {
			if ( response.result === false ) {
				videojs.log.warn( response.error );
			}
			canAutoPlay = response.result;
			videojs.log( "canAutoPlay = [" + canAutoPlay + "]" );
			startInternal();
		} );
	};

	/**
	* Check if Video.JS, plugins and scripts are ready.
	* @returns {bool}
	*/
	namespace.isPlayerReady = function() {
		// IMA SDK
		if ( !namespace.isScriptLoaded( namespace.getImaSdkUrl() ) ) {
			videojs.log.error( "IMA SDK from Google did not load." );
			if ( !namespace.isScriptLoaded( namespace.getFallbackImaUrl() ) ) {
				videojs.log.error( "Loading IMA SDK fallback." );
				namespace.loadScript( namespace.getFallbackImaUrl() );
				isImaSdkLoaded = true;
			} else {
				isImaSdkLoaded = true;
			}
		} else {
			isImaSdkLoaded = true;
		}

		isImaSdkReady = typeof ( window.google ) !== "undefined" && typeof ( window.google.ima ) !== "undefined";

		// If IMA is not loaded, and we have not loaded the fallback, and the jsTimeout has passed, then load the fallback IMA SDK JS.
		if ( !isImaSdkReady && !namespace.isScriptLoaded( namespace.getFallbackImaUrl() ) && ( Date.now() - jsStartTime ) > namespace.getJsTimeout() ) {
			namespace.loadScript( namespace.getFallbackImaUrl() );
		}

		// GA
		if ( !namespace.isScriptLoaded( namespace.getGaUrl() ) ) {
			videojs.log.error( "Google Analytics from Google did not load." );
			if ( !namespace.isScriptLoaded( namespace.getFallbackGaUrl() ) ) {
				videojs.log.error( "Loading Google Analytics fallback." );
				namespace.loadScript( namespace.getFallbackGaUrl() );
				isGaLoaded = true;
			} else {
				isGaLoaded = true;
			}
		} else {
			isGaLoaded = true;
		}

		isGaReady = typeof ( window.ga ) !== "undefined" && typeof ( window.ga.getAll ) === "function";

		// If Google Analytics is not loaded, and we have not loaded the fallback, and the jsTimeout has passed, then load the fallback Google Analytics JS.
		if ( !isGaReady && !namespace.isScriptLoaded( namespace.getFallbackGaUrl() ) && ( Date.now() - jsStartTime ) > namespace.getJsTimeout() ) {
			namespace.loadScript( namespace.getFallbackGaUrl() );
		}

		return isImaSdkLoaded && isImaSdkReady && isGaLoaded && isGaReady && window.HRST;
	};

	/**
	* Get the poster URL, whether from anime or the default poster.
	*/
	var getPosterUrl = function( el, poster, id, hasAnime ) {
		var posterMedia = namespace.isPosterMedia( el );
		var animeEnabled = namespace.isAnimeEnabled();
		if ( posterMedia && animeEnabled && hasAnime ) {
			return namespace.getAnimeUrl() + id + ".gif";
		}
		return namespace.resizePoster( poster );
	};

	/**
	* Register video player events.
	*/
	var registerPlayerEvents = function( el, player ) {
		player.ready( function() {
			var posterUrl = getPosterUrl( el, player.playlist.sources[ 0 ].poster, player.playlist.sources[ 0 ].id, player.playlist.hasAnime );
			var shareOptions = {
				socials: [
					"fb",
					"tw",
				],

				url: window.location.href,
				title: player.playlist.sources[ 0 ].title,
				description: player.playlist.sources[ 0 ].title,
				image: posterUrl,

				fbAppId: getFbAppId(),
				redirectUri: window.location.href,
			};

			this.share( shareOptions );
		} );

		var posterMedia = namespace.isPosterMedia( el );

		var startEvent = posterMedia ? "inViewReady" : "click";

		if ( namespace.isBrowserSafari() ) {
			startEvent = "click";
		}

		if ( !canAutoPlay ) {
			startEvent = "click";
		}

		if ( ismobilejs.any ) {
			startEvent = "touchend";
		}

		if ( posterMedia ) {
			registerEndedHandler( el, player );
		}

		registerQuartileEvents( player );

		videojs.log( "Ad startEvent = [" + startEvent + "]" );

		player.one( startEvent, function() {
			if ( !namespace.hasClass( el, "LumiereAutoStarted" ) ) {
				namespace.addClass( el, "LumiereAutoStarted" );
			}

			this.ima.initializeAdDisplayContainer();
			this.ima.requestAds();
			this.play();
		} );

		player.one( "played-q0", function() {
			refreshPlayerControls( this );
		} );

		player.on( "click", function() {
			if ( !namespace.hasClass( el, "UserEventTrigger" ) ) {
				namespace.addClass( el, "UserEventTrigger" );
			}
		} );

		player.on( "touchend", function() {
			if ( !namespace.hasClass( el, "UserEventTrigger" ) ) {
				namespace.addClass( el, "UserEventTrigger" );
			}
		} );

		registerInViewEvents( el, player );
	};

	/**
	* Check if Flex Ads are visible.
	*/
	var checkFlexAdsVisible = function() {
		var flexFrame = document.querySelectorAll( "#gpt-ad-flex iframe" );
		var nFrames = flexFrame.length;

		if ( nFrames === 0 || ( nFrames > 0 && ( flexFrame[ 0 ].style.zIndex === "" || flexFrame[ 0 ].style.display === "none" ) ) ) {
			return false;
		} else {
			return true;
		}
	};

	/**
	* Trigger inViewReady event after flex ads are dismissed.
	*/
	var triggerInViewReady = function( player ) {
		if ( !checkFlexAdsVisible() ) {
			player.trigger( "inViewReady" );
			return;
		}

		videojs.log( player.id() + " flex ads visible" );

		( function() {
			var startTime = Date.now();

			var waitForFlexAds = function() {
				if ( !checkFlexAdsVisible() ) {
					videojs.log( player.id() + " flex ads dismissed" );
					player.trigger( "inViewReady" );
					return;
				}

				if ( ( Date.now() - startTime ) > 25000 ) {
					videojs.log( player.id() + " flex ads timeout" );
					player.trigger( "inViewReady" );
					return;
				}

				setTimeout( waitForFlexAds, 500 );
			};

			waitForFlexAds();
		} )();
	};

	namespace.pauseAllPlayers = function( selfId, selfEmbedId ) {
		var videos = document.getElementsByClassName( namespace.getPlayerClass() );

		if ( videos ) {
			for ( var i = 0; i < videos.length; i++ ) {

				if ( selfId && selfEmbedId &&
					videos[ i ].getAttribute( "id" ) === selfId &&
					videos[ i ].getAttribute( "data-player-id" ) === selfEmbedId ) {
					continue;
				}

				if ( !namespace.hasClass( videos[ i ], namespace.getVideoLoadedClass() ) ) {
					continue;
				}

				if ( !namespace.hasClass( videos[ i ], namespace.getInViewReadyClass() ) ) {
					continue;
				}

				var videoElId = "lumiere-" + videos[ i ].getAttribute( "data-player-id" ) + "-" + videos[ i ].getAttribute( "id" );
				var playerInst = videojs( videoElId );

				if ( !playerInst ) {
					continue;
				}

				if ( !playerInst.ima ) {
					continue;
				}

				videojs.log( "pausing " + videoElId );

				if ( playerInst.ima.adPlaying ) {
					playerInst.ima.pauseAd();
					if ( !namespace.hasClass( videos[ i ], "LumiereAdPaused" ) ) {
						namespace.addClass( videos[ i ], "LumiereAdPaused" );
					}
				} else {
					playerInst.pause();
					if ( !namespace.hasClass( videos[ i ], "LumierePaused" ) ) {
						namespace.addClass( videos[ i ], "LumierePaused" );
					}
				}
			}
		}
	};

	/**
	* Register video player inView events.
	*/
	var registerInViewEvents = function( el, player ) {
		var id = el.getAttribute( "id" );
		var embedId = el.getAttribute( "data-player-id" );
		var selector = "#" + id + "." + namespace.getPlayerClass() + "[data-player-id=\"" + embedId + "\"]";

		player.on( "pause", function() {
			if ( !namespace.hasClass( el, "LumierePaused" ) ) {
				namespace.addClass( el, "LumierePaused" );
			}
		} );

		player.on( "ads-ima-pause", function() {
			if ( !namespace.hasClass( el, "LumiereAdPaused" ) ) {
				namespace.addClass( el, "LumiereAdPaused" );
			}
		} );

		inView.threshold( 0.5 );

		inView( selector )
			.on( "enter", function( playerEl ) {
				if ( !namespace.hasClass( playerEl, namespace.getInViewReadyClass() ) ) {
					return;
				}

				if ( !namespace.isPosterMedia( playerEl ) ) {
					return;
				}

				var videoElId = "lumiere-" + playerEl.getAttribute( "data-player-id" ) + "-" + playerEl.getAttribute( "id" );
				var playerInst = videojs( videoElId );

				if ( !playerInst ) {
					return;
				}

				if ( !playerInst.ima ) {
					return;
				}

				videojs.log( "entered viewport " + videoElId );

				namespace.pauseAllPlayers( playerEl.getAttribute( "id" ), playerEl.getAttribute( "data-player-id" ) );

				if ( !namespace.hasClass( playerEl, "LumiereAutoStarted" ) ) {
					namespace.addClass( playerEl, "LumiereAutoStarted" );
					triggerInViewReady( playerInst );
					return;
				}

				if ( namespace.isBrowserSafari() ) {
					if ( !namespace.hasClass( playerEl, "UserEventTrigger" ) ) {
						return;
					}
				}

				if ( namespace.hasClass( playerEl, "LumiereAdPaused" ) ) {
					namespace.removeClass( playerEl, "LumiereAdPaused" );
					playerInst.ima.resumeAd();
					return;
				}

				if ( namespace.hasClass( playerEl, "LumierePaused" ) && !playerInst.ima.adPlaying ) {
					namespace.removeClass( playerEl, "LumierePaused" );
					playerInst.play();
					return;
				}
			} )
			.on( "exit", function( playerEl ) {
				if ( !namespace.hasClass( playerEl, namespace.getInViewReadyClass() ) ) {
					return;
				}

				if ( !namespace.isPosterMedia( playerEl ) ) {
					return;
				}

				var videoElId = "lumiere-" + playerEl.getAttribute( "data-player-id" ) + "-" + playerEl.getAttribute( "id" );

				videojs.log( "exited viewport " + videoElId );
			} );
	};

	/**
	* Register video player quartile events.
	*/
	var registerQuartileEvents = function( player ) {
		var checkPlayedQuartile = function( player, q ) {
			var played = player.currentTime() / player.duration();

			return played >= ( q / 4 );
		};

		var checkQ0 = function() {
			if ( this.currentTime() > 0 ) {
				this.trigger( "played-q0" );
			} else {
				this.one( "timeupdate", checkQ0 );
			}
		};

		var checkQ1 = function() {
			if ( checkPlayedQuartile( this, 1 ) ) {
				this.trigger( "played-q1" );
			} else {
				this.one( "timeupdate", checkQ1 );
			}
		};

		var checkQ2 = function() {
			if ( checkPlayedQuartile( this, 2 ) ) {
				this.trigger( "played-q2" );
			} else {
				this.one( "timeupdate", checkQ2 );
			}
		};

		var checkQ3 = function() {
			if ( checkPlayedQuartile( this, 3 ) ) {
				this.trigger( "played-q3" );
			} else {
				this.one( "timeupdate", checkQ3 );
			}
		};

		var checkQ4 = function() {
			if ( checkPlayedQuartile( this, 4 ) ) {
				this.trigger( "played-q4" );
			} else {
				this.one( "timeupdate", checkQ4 );
			}
		};

		player.one( "timeupdate", checkQ0 );
		player.one( "timeupdate", checkQ1 );
		player.one( "timeupdate", checkQ2 );
		player.one( "timeupdate", checkQ3 );
		player.one( "timeupdate", checkQ4 );
	};

	/**
	* Register video player Ad events.
	*/
	namespace.registerAdEvents = function( el, player ) {
		var imaEvents = [
			google.ima.AdEvent.Type.AD_BREAK_READY,
			google.ima.AdEvent.Type.AD_METADATA,
			google.ima.AdEvent.Type.ALL_ADS_COMPLETED,
			google.ima.AdEvent.Type.CLICK,
			google.ima.AdEvent.Type.COMPLETE,
			google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED,
			google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED,
			google.ima.AdEvent.Type.DURATION_CHANGE,
			google.ima.AdEvent.Type.FIRST_QUARTILE,
			google.ima.AdEvent.Type.IMPRESSION,
			google.ima.AdEvent.Type.INTERACTION,
			google.ima.AdEvent.Type.LINEAR_CHANGED,
			google.ima.AdEvent.Type.LOADED,
			google.ima.AdEvent.Type.LOG,
			google.ima.AdEvent.Type.MIDPOINT,
			google.ima.AdEvent.Type.PAUSED,
			google.ima.AdEvent.Type.RESUMED,
			google.ima.AdEvent.Type.SKIPPABLE_STATE_CHANGED,
			google.ima.AdEvent.Type.SKIPPED,
			google.ima.AdEvent.Type.STARTED,
			google.ima.AdEvent.Type.THIRD_QUARTILE,
			google.ima.AdEvent.Type.USER_CLOSE,
			google.ima.AdEvent.Type.VOLUME_CHANGED,
			google.ima.AdEvent.Type.VOLUME_MUTED,
			google.ima.AdErrorEvent.Type.AD_ERROR,
		];

		for ( var i = 0; i < imaEvents.length; i++ ) {
			player.ima.addEventListener( imaEvents[ i ], function( event ) {
				player.trigger( "ads-ima-" + event.type );
			} );
		}

		player.ima.addEventListener( google.ima.AdEvent.Type.STARTED, function( adEvent ) {
			if ( adEvent.type !== google.ima.AdEvent.Type.STARTED ) {
				return;
			}

			var companionSizes = ismobilejs.phone ? [
				{
					width: 320,
					height: 50,
					type: "leaderboard",
				},
				{
					width: 300,
					height: 250,
					type: "rectangle",
				},
			] : [
				{
					width: 728,
					height: 90,
					type: "leaderboard",
				},
				{
					width: 300,
					height: 250,
					type: "rectangle",
				},
			];

			insertCompanionAds( adEvent, el, companionSizes );
		} );
	};

	/**
	* Retrieve and insert Companion Ads.
	*/
	var insertCompanionAds = function( adEvent, el, companionSizes ) {
		var ad = adEvent.getAd();
		var selectionCriteria = new google.ima.CompanionAdSelectionSettings();

		selectionCriteria.resourceType = google.ima.CompanionAdSelectionSettings.ResourceType.ALL;
		selectionCriteria.creativeType = google.ima.CompanionAdSelectionSettings.CreativeType.ALL;
		selectionCriteria.sizeCriteria = google.ima.CompanionAdSelectionSettings.SizeCriteria.IGNORE;

		for ( var i = 0; i < companionSizes.length; i++ ) {
			var companionAds = ad.getCompanionAds( companionSizes[ i ].width, companionSizes[ i ].height, selectionCriteria );
			if ( !companionAds || companionAds.length === 0 ) {
				continue;
			}

			for ( var j = 0; j < companionAds.length; j++ ) {
				if ( !companionAds[ j ] ) {
					continue;
				}

				var content = companionAds[ j ].getContent();
				if ( !content ) {
					continue;
				}

				var divId = el.getAttribute( "data-player-id" ) + "-" + companionSizes[ i ].type;
				var div = document.getElementById( divId );
				if ( !div ) {
					continue;
				}

				if ( companionAds[ j ].getWidth() === companionSizes[ i ].width && companionAds[ j ].getHeight() === companionSizes[ i ].height ) {
					videojs.log( companionAds[ j ].getWidth() + "x" + companionAds[ j ].getHeight() + " companion ad " + divId );
					div.innerHTML = content;
					namespace.addClass( div, "inserted" );
				}
			}
		}
	};

	/**
	* checks if Anime Gif exists before moving on
	* @param {object} el - Element to be checked.
	* @param {object} videoData - Video data retrieved from Nitehawk.
	*/
	namespace.checkAnime = function( el, videoData ) {
		var id = videoData[ 0 ].id;
		var animeEndpoint = namespace.getAnimeUrl() + id + ".gif";

		var animeCallback = function( hasAnime ) {
			insertPlayer( el, videoData, hasAnime );
		};

		namespace.xhrHead( animeEndpoint, animeCallback );
	};


	/**
	* Insert video player inside element and append video loaded class.
	* @param {object} el - Element to be checked.
	* @param {object} videoData - Video data retrieved from Nitehawk.
	* @param {boolean} hasAnime - does this video have an animated gif from anime.
	*/
	var insertPlayer = function( el, videoData, hasAnime ) {
		if ( namespace.hasClass( el, namespace.getVideoLoadedClass() ) ) {
			return;
		}

		namespace.addClass( el, namespace.getVideoLoadedClass() );

		var insertPlayerInternal = function() {
			var videoElId = "lumiere-" + el.getAttribute( "data-player-id" ) + "-" + el.getAttribute( "id" );
			if ( document.getElementById( videoElId ) ) {
				videojs.log.error( videoElId + " already in use" );
				return;
			}

			var videoEl = document.createElement( "video" );
			videoEl.setAttribute( "id", videoElId );
			videoEl.setAttribute( "class", "video-js vjs-default-skin vjs-big-play-centered" );
			videoEl.setAttribute( "playsinline", null );
			el.appendChild( videoEl );

			var player = videojs( videoEl );

			player.controls( true );
			player.autoplay( false );
			player.preload( false );
			player.fluid( true );

			var imaOptions = {
				id: videoElId,
				adTagUrl: null,
				vastLoadTimeout: 10000,
				adsRenderingSettings: {
					bitrate: -1,
					mimeTypes: [
						"video/mp4",
						"video/webm",
					],
					loadVideoTimeout: 10000,
				},
				contribAdsSettings: {
					timeout: 10000,
					prerollTimeout: 1000,
				},
				showCountdown: false,
				disableCustomPlaybackForIOS10Plus: ismobilejs.apple.device,
			};

			if ( !player.playlist ) {
				player.playlist = {};
			}

			player.adTagUrl = null;
			player.playlist.currentIndex = 0;
			player.playlist.sources = videoData;
			player.playlist.hasAnime = hasAnime;

			player.ima( imaOptions, function() {
				namespace.registerAdEvents( el, player );
				player.ima.startFromReadyCallback();
			} );

			namespace.requestAmazonBid( el, player, namespace.initialBidCallback, "videoSlot" );
		};

		var insertFail = function() {
			var isAdBlock = isImaSdkLoaded && !isImaSdkReady && isGaLoaded && isGaReady;

			var videoElId = "lumiere-" + el.getAttribute( "data-player-id" ) + "-" + el.getAttribute( "id" );
			videojs.log.error( "timeout inserting " + videoElId );

			if ( isAdBlock ) {
				var pEl = document.createElement( "p" );
				pEl.innerHTML = "Video could not be loaded. If you have Ad Block enabled, please add this site to the white list.";
				el.appendChild( pEl );
			}
		};

		namespace.waitForThenRun( namespace.isPlayerReady, insertPlayerInternal, insertFail );
	};

	/**
	* Initial bid request callback.
	*/
	namespace.initialBidCallback = function( el, player, bid ) {
		setNextSource( el, player, false, bid );

		registerPlayerEvents( el, player );

		namespace.startAnalytics( el, player );

		namespace.addClass( el, namespace.getInViewReadyClass() );

		var dehydratedRecs = getDehydratedRecsCount( el );
		if ( dehydratedRecs > 0 ) {
			namespace.hydratePlaylist( el, true );
		}

		captionsSettingsFix();

		window.scrollTo( window.scrollX, window.scrollY - 1 );
		window.scrollTo( window.scrollX, window.scrollY + 1 );
	};

	var captionsSettingsFix = function() {
		var settingsModals = document.querySelectorAll( ".vjs-text-track-settings .vjs-modal-dialog-content" );

		if ( !settingsModals || settingsModals.length === 0 ) {
			return;
		}

		for ( var i = 0; i < settingsModals.length; i++ ) {
			var children = settingsModals[ i ].children;

			if ( !children || children.length === 0 ) {
				continue;
			}

			for ( var j = 0; j < children.length; j++ ) {
				children[ j ].style = "color: black;";
			}
		}
	};

	namespace.getVideoRecIndex = function( id ) {
		var recIndex = -1;

		for ( var i = 0; i < window.hearstLumiereRecs.length; i++ ) {
			if ( window.hearstLumiereRecs[ i ].id === id ) {
				recIndex = i;
				break;
			}
		}

		return recIndex;
	};

	/**
	* Retrieve video recommendations.
	*/
	namespace.getVideoRecs = function( id, isNowcast ) {
		if ( !window.hearstLumiereRecs ) {
			return [];
		}

		var recIndex = namespace.getVideoRecIndex( id );
		if ( recIndex < 0 ) {
			return [];
		}

		if ( isNowcast ) {
			return window.hearstLumiereRecs[ recIndex ].playlist;
		}

		if ( window.hearstLumiereRecs[ recIndex ].playlist.length === 0 ) {
			return [];
		}

		var watchedList = getVideoWatchedList();
		if ( watchedList.length === 0 ) {
			return window.hearstLumiereRecs[ recIndex ].playlist;
		}

		window.hearstLumiereRecs[ recIndex ].playlist = window.hearstLumiereRecs[ recIndex ].playlist.filter( function( videoRec ) {
			return watchedList.indexOf( videoRec.id ) === -1;
		} );

		return window.hearstLumiereRecs[ recIndex ].playlist;
	};

	/**
	* Retrieve watched videos list.
	*/
	var getVideoWatchedList = function() {
		var rawList = null;
		var watchedList = [];

		if ( typeof ( window.localStorage ) === "undefined" ) {
			return watchedList;
		}

		try {
			rawList = localStorage.getItem( "hearstLumiereWatched" );
		} catch ( e ) {
			return watchedList;
		}

		if ( rawList ) {
			try {
				watchedList = JSON.parse( rawList );
			} catch ( e ) {
				watchedList = [];
			}
		}

		return watchedList;
	};

	/**
	* Include video in watched videos list.
	*/
	var setVideoWatched = function( id ) {
		if ( typeof ( window.localStorage ) === "undefined" ) {
			return;
		}

		var watchedList = getVideoWatchedList();

		if ( watchedList.indexOf( id ) > -1 ) {
			return;
		}

		watchedList.push( id );

		if ( watchedList.length > 100 ) {
			watchedList.shift();
		}

		try {
			localStorage.setItem( "hearstLumiereWatched", JSON.stringify( watchedList ) );
		} catch ( e ) {
			return;
		}

		videojs.log( id + " video watched" );
	};

	/**
	* Set next playlist item source.
	*/
	var setNextSource = function( el, player, autoplay, bid ) {
		var hasAnime = false;
		var videoElId = "lumiere-" + el.getAttribute( "data-player-id" ) + "-" + el.getAttribute( "id" );
		var videoRecs = namespace.getVideoRecs( el.getAttribute( "data-article-id" ) );

		var newRecs = videoRecs.filter( function( videoRec ) {
			for ( var i = 0; i < player.playlist.sources.length; i++ ) {
				var sourceId = player.playlist.sources[ i ].id;
				if ( sourceId === videoRec.id ) {
					return false;
				}
			}
			return true;
		} );

		if ( newRecs.length > 0 ) {
			videojs.log( videoElId + " " + videoRecs.length + " video recommendations" );
			player.playlist.sources = player.playlist.sources.concat( newRecs );
		}

		if ( player.playlist.currentIndex < player.playlist.sources.length ) {
			if ( player.playlist.currentIndex === 0 ) {
				hasAnime = player.playlist.hasAnime;
			}
			var posterUrl = getPosterUrl( el, player.playlist.sources[ player.playlist.currentIndex ].poster, player.playlist.sources[ player.playlist.currentIndex ].id, hasAnime );

			if ( player.isNowcast ) {
				player.adTagUrl = namespace.getNowcastPrerollTag();
				if ( bid ) {
					player.adTagUrl += "&scp=" + bid;
				}
				videojs.log( "nowcast preroll tag: " + player.adTagUrl );
			} else {
				if ( !player.playlist.sources[ player.playlist.currentIndex ].ads_disabled ) {
					player.adTagUrl = namespace.getAdTagUrl( el, player, bid );
				} else {
					player.adTagUrl = null;
				}
			}

			var contentSrc = [
				{
					src: player.playlist.sources[ player.playlist.currentIndex ].url,
					type: "application/x-mpegURL",
				},
			];

			if ( player.playlist.sources[ player.playlist.currentIndex ].fallback ) {
				contentSrc.push( {
					src: player.playlist.sources[ player.playlist.currentIndex ].fallback,
					type: "video/mp4",
				} );
			}

			player.poster( posterUrl );
			player.ima.setContentWithAdTag( contentSrc, player.adTagUrl, autoplay );

			if ( player.playlist.sources[ player.playlist.currentIndex ].text ) {
				player.addRemoteTextTrack( {
					kind: "captions",
					mode: "disabled",
					src: player.playlist.sources[ player.playlist.currentIndex ].text.url,
					language: player.playlist.sources[ player.playlist.currentIndex ].text.language,
					srclang: player.playlist.sources[ player.playlist.currentIndex ].text.language,
					label: player.playlist.sources[ player.playlist.currentIndex ].text.full_language,
					default: false,
				}, false );
			}

			player.dock( {
				title: player.playlist.sources[ player.playlist.currentIndex ].title,
				description: "by " + player.playlist.sources[ player.playlist.currentIndex ].source,
			} );

			setVideoWatched( player.playlist.sources[ player.playlist.currentIndex ].id );
			setVideoWatched( player.playlist.sources[ player.playlist.currentIndex ].embedId );

			videojs.log( player.id() + " set player source " + player.playlist.sources[ player.playlist.currentIndex ].id );

			player.playlist.currentIndex++;
		}

		if ( player.playlist.currentIndex < player.playlist.sources.length ) {
			player.playlist.videoClicked = false;

			var divEl = document.createElement( "div" );

			var countdownEl = document.createElement( "div" );
			var countdownSize = player.currentHeight() / 25;
			countdownEl.setAttribute( "id", "next-countdown-" + player.id() );
			countdownEl.style.cssText = "max-height:" + countdownSize + "px;";

			var titleEl = document.createElement( "p" );
			var fontSize = player.currentHeight() / 25;
			titleEl.innerHTML = player.playlist.sources[ player.playlist.currentIndex ].title;
			titleEl.style.cssText = "font-size:" + fontSize + "px; margin-top:" + fontSize + "px;";

			var imgEl = document.createElement( "img" );
			posterUrl = getPosterUrl( el, player.playlist.sources[ player.playlist.currentIndex ].poster, player.playlist.sources[ player.playlist.currentIndex ].id, false );
			imgEl.setAttribute( "src", posterUrl );
			imgEl.style.cssText = "width: 100%; height: auto;";

			divEl.appendChild( countdownEl );
			divEl.appendChild( imgEl );
			divEl.appendChild( titleEl );

			divEl.addEventListener( "click", function() {
				player.playlist.videoClicked = true;
			} );

			player.overlay( {
				overlays: [
					{
						content: divEl,
						align: "center",
						start: "show-overlay",
						end: "hide-overlay",
					},
				],
			} );
		}
	};

	/**
	* Refresh vieo player controls.
	*/
	var refreshPlayerControls = function( player ) {
		var playControl = document.querySelectorAll( "#" + player.id() + " " + ".vjs-play-control" );

		if ( playControl && playControl.length > 0 ) {
			playControl = playControl[ 0 ];
			namespace.removeClass( playControl, "vjs-ended" );
		}
	};

	/**
	* Register playlist ended handler.
	*/
	var registerEndedHandler = function( el, player ) {
		player.on( "ended", function() {
			if ( player.playlist.currentIndex === player.playlist.sources.length ) {
				videojs.log( player.id() + " playlist complete" );
				player.trigger( "playlistComplete" );
				registerQuartileEvents( this );
				return;
			}

			player.trigger( "playlistItem" );
			registerQuartileEvents( this );

			player.controls( false );
			player.trigger( "show-overlay" );

			var progressId = "#next-countdown-" + this.id();

			player.playlist.progress = new progressbarjs.Line( progressId, {
				strokeWidth: 4,
			} );

			player.playlist.progress.set( 0 );

			( function() {
				var startTime = Date.now();
				var countdown = 5;

				var waitFor = function() {
					if ( ( Date.now() - startTime ) < 5000 && !player.playlist.videoClicked ) {
						countdown--;

						player.playlist.progress.animate( ( 5 - countdown ) / 5, {
							duration: 1000,
						} );

						setTimeout( waitFor, 1000 );
						return;
					}

					if ( !inView.is( el ) ) {
						videojs.log( player.id() + " playlist out of view" );

						if ( player.playlist.progress ) {
							player.playlist.progress.destroy();
						}

						player.trigger( "hide-overlay" );
						player.controls( true );
						refreshPlayerControls( player );
						return;
					}

					player.trigger( "hide-overlay" );
					player.controls( true );
					refreshPlayerControls( player );

					namespace.requestAmazonBid( el, player, nextSourceBidCallback, "videoSlot" );
				};

				waitFor();
			} )();
		} );
	};

	/**
	* Bid request callback for setNextSource.
	*/
	var nextSourceBidCallback = function( el, player, bid ) {
		setNextSource( el, player, false, bid );
		player.ima.requestAds();
		player.play();
	};

	/**
	* Video player entry point for nowcast playback.
	*/
	namespace.startNowcast = function() {
		var startNowcastInternal = function() {
			namespace.loadEnvVars();

			loadPlayerScripts();

			if ( !namespace.isScriptLoaded( namespace.getImaDaiScriptUrl() ) ) {
				namespace.loadScript( namespace.getImaDaiScriptUrl() );
			}

			namespace.videojs = videojs;

			if ( namespace.getLogLevel() === "all" ) {
				namespace.videojs.log.level( "all" );
			} else {
				namespace.videojs.log.level( "error" );
			}

			var loadFail = function() {
				videojs.log.error( "timeout waiting for DOM ready" );
			};

			namespace.waitForThenRun( namespace.isDOMReady, namespace.loadNowcast, loadFail );
		};

		canAutoplay.video( {
			timeout: 500,
			inline: true,
		} ).then( function( response ) {
			if ( response.result === false ) {
				videojs.log.warn( response.error );
			}
			canAutoPlay = response.result;
			videojs.log( "canAutoPlay = [" + canAutoPlay + "]" );
			startNowcastInternal();
		} );
	};

	init();
} )( window.hearstLumierePlayer = window.hearstLumierePlayer || /* istanbul ignore next */ {} );



//////////////////
// WEBPACK FOOTER
// ./src/player.js
// module id = 92
// module chunks = 0